// src/data/searchData.js

export const siteContent = [
  {
    label: "Gastos médicos",
    path: "/gastos-medicos",
    keywords: [
      "seguros",
      "colectivo",
      "hospitalización",
      "consultas",
      "médico",
      "grupo",
      "beneficios",
      "gastos",
      "medicos",
      "protección",
      "laboratorio",
      "medicamento",
      "medicamentos",
      "ambulancia",
      "enfermería",
      "atención",
      "orientación",
      "dental",
      "maternidad",
      "extranjero",
    ],
  },
  {
    label: "Accidentes",
    path: "/accidentes",
    keywords: [
      "seguros",
      "accidente",
      "fallecimiento",
      "hospital",
      "póliza",
      "gastos",
      "protección",
      "perdidas",
      "orgánicas",
      "órganos",
      "muerte",
      "accidental",
      "reembolso",
      "gastos",
      "protección",
    ],
  },
  {
    label: "Vida",
    path: "/vida",
    keywords: [
      "seguros",
      "fallecimiento",
      "invalidez",
      "beneficiario",
      "empresa",
      "enfermedades",
      "terminales",
      "enfermedades terminales",
      "edad",
      "menor",
      "costos",
      "largo",
      "plazo",
      "tranquilidad",
      "oportunidad",
      "bienestar",
    ],
  },
  {
    label: "Auto",
    path: "/auto",
    keywords: [
      "seguros",
      "vehículo",
      "auto",
      "carro",
      "amplia",
      "limitada",
      "básica",
      "responsabilidad civil",
      "coche",
      "indemnizar",
      "daños",
      "choques",
      "coberturas",
      "reparar",
      "robo",
      "asistencia",
      "legal",
      "gastos",
      "médicos",
      "responsabilidad",
      "civil",
      "vial",
    ],
  },
  {
    label: "Viajes",
    path: "/viajes",
    keywords: [
      "seguros",
      "asistencia",
      "extranjero",
      "emergencias",
      "accidente",
      "cobertura",
      "hospital",
      "viaje",
      "equipaje",
      "perdida",
      "accidente",
      "emergencias",
      "emergencia",
      "viajes",
      "cancelación",
      "destino",
      "viaja",
      "viajero",
      "maletas",
      "intercambios",
      "estudiantiles",
    ],
  },
  {
    label: "Hogar",
    path: "/hogar",
    keywords: [
      "seguros",
      "casa",
      "vivienda",
      "protección",
      "robo",
      "incendio",
      "daños",
      "catástrofes",
      "escombro",
      "equipo",
      "electrodoméstico",
      "cristales",
      "asistencia",
      "extraordinario",
      "objetos",
      "personales",
      "inmueble",
      "hogar",
      "rentado",
      "propio",
    ],
  },
  {
    label: "Ahorro",
    path: "/ahorro",
    keywords: [
      "crecer",
      "dinero",
      "ahorro",
      "seguros",
      "abonar",
      "cantidad",
      "apoyar",
      "patrimonio",
      "financiero",
      "plan",
      "cobertura",
      "fallecimiento",
      "invalidez",
      "deducible",
      "impuestos",
      "económica",
      "protección",
      "certidumbre",
      "futuro",
      "complemento",
    ],
  },
  {
    label: "Mascotas",
    path: "/mascotas",
    keywords: [
      "seguros",
      "mascota",
      "mascotas",
      "perro",
      "perros",
      "gatos",
      "gastos",
      "funerarios",
      "compensación",
      "búsqueda",
      "médicos",
      "robo",
      "violencia",
      "hospedaje",
      "veterinaria",
      "veterinarias",
      "atención",
      "red",
    ],
  },
  {
    label: "Responsabilidad civil",
    path: "/responsabilidad-civil",
    keywords: [
      "seguros",
      "genera",
      "profesionales",
      "responsabilidad",
      "civil",
      "contratistas",
      "equipo",
      "viajero",
      "guarderías",
      "tipos",
      "cruzada",
      "arrendatario",
      "productos",
      "profesional",
      "contaminación",
      "talleres",
      "actividades",
      "inmuebles",
      "carga",
      "descarga",
      "estacionamiento",
      "daños",
      "extranjero",
    ],
  },
  {
    label: "Flotillas",
    path: "/flotillas",
    keywords: [
      "seguros",
      "flotillas",
      "carro",
      "auto",
      "camiones",
      "remolques",
      "autobuses",
      "motocicletas",
      "pickup",
      "movilidad",
      "coche",
      "robo",
      "asistencia",
      "vial",
      "responsabilidad",
      "civil",
      "daños",
      "choque",
      "médicos",
      "gastos",
      "legal",
      "coberturas",
    ],
  },
  {
    label: "Vida Colectiva",
    path: "/seguro-de-vida-colectivo",
    keywords: [
      "seguros",
      "vida",
      "colectivo",
      "personas",
      "beneficios",
      "empresa",
      "personal",
      "póliza",
      "grupo",
      "pago",
      "motivación",
      "conciencia",
      "social",
      "fallecimiento",
      "indemnización",
      "invalidez",
      "total",
      "permanente",
      "muerte",
      "accidental",
      "gastos",
      "funerarios",
      "enfermedades",
      "terminales",
    ],
  },
  {
    label: "Gastos médicos colectivo",
    path: "/gastos-medicos-colectivo",
    keywords: [
      "seguros",
      "gastos",
      "médicos",
      "colectivo",
      "cobertura",
      "médica",
      "empresarial",
      "personas",
      "personal",
      "beneficios",
      "individual",
      "hospitalización",
      "consultas",
      "médicas",
      "cirugías",
      "laboratorios",
      "medicamentos",
      "medicinas",
      "ambulancias",
      "enfermería",
      "atención",
      "especializada",
      "hospital",
      "pago",
      "familiares",
      "deducible",
      "impuestos",
      "póliza",
      "extensión",
    ],
  },
  {
    label: "Aviación",
    path: "/aviacion",
    keywords: [
      "seguros",
      "avión",
      "aviación",
      "vuelo",
      "aviones",
      "vuelos",
      "despegue",
      "casco",
      "responsabilidad",
      "civil",
      "daños",
      "carga",
      "equipaje",
      "maletas",
      "pasajeros",
      "tripulantes",
      "tripulación",
      "gastos",
      "médicos",
      "riesgos",
      "actividades",
      "aeronáutico",
      "aeronaves",
      "superficie",
      "aeropuerto",
    ],
  },
  {
    label: "Embarcaciones",
    path: "/embarcaciones",
    keywords: [
      "seguros",
      "barco",
      "embarcaciones",
      "mar",
      "marítimo",
      "destino",
      "envíos",
      "turísticos",
      "lanchas",
      "veleros",
      "yates",
      "protección",
      "huelgas",
      "motines",
      "responsabilidad",
      "casco",
      "avería",
      "civil",
      "abordaje",
    ],
  },
  {
    label: "Transporte",
    path: "/transporte",
    keywords: [
      "transporte",
      "seguros",
      "envíos",
      "proteger",
      "protección",
      "mercancía",
      "bienes",
      "tránsito",
      "marítimo",
      "terrestre",
      "aéreo",
      "medios",
      "riesgos",
      "incendio",
      "robo",
      "rayo",
      "explosión",
      "rotura",
      "rajadura",
      "derrame",
      "pérdida",
      "carga",
      "descarga",
      "machas",
      "colisiones",
      "volcaduras",
      "vehículo",
      "descarrilamiento",
      "contaminación",
      "contacto",
    ],
  },
  {
    label: "Accidentes Colectivo",
    path: "/accidentes-colectivo",
    keywords: [
      "seguros",
      "accidente",
      "accidentes",
      "colectivo",
      "pago",
      "directo",
      "hospital",
      "reembolso",
      "gastos",
      "médicos",
      "caso",
      "pérdidas",
      "orgánicas",
      "órganos",
      "muerte",
      "accidental",
      "funerarios",
      "funeral",
      "protección",
    ],
  },
  {
    label: "Construcción",
    path: "/construccion",
    keywords: [
      "construcción",
      "seguros",
      "montaje",
      "cimientos",
      "inversión",
      "obra",
      "protegida",
      "protección",
      "incendio",
      "explosión",
      "rayo",
      "robo",
      "violencia",
      "hurto",
      "riesgos",
      "fabricante",
      "daños",
      "propiedades",
      "maquinaria",
      "equipo",
      "civil",
      "gastos",
      "terremoto",
      "temblor",
      "erupción",
      "volcánica",
      "fenómenos",
      "hidrometeorológicos",
      "escombros",
      "remoción",
      "instalaciones",
      "construcciones",
      "terceros",
    ],
  },
  {
    label: "Terrorismo",
    path: "/terrorismo",
    keywords: [
      "terrorismo",
      "seguros",
      "eventos",
      "extraordinarios",
      "daño",
      "físico",
      "inmuebles",
      "muebles",
      "bienes",
      "legalmente",
      "responsable",
      "acto",
      "sabotaje",
      "huelgas",
      "alborotos",
      "conmoción",
      "civil",
      "malicioso",
      "pérdida",
      "riesgos",
      "gastos",
      "hurto",
      "ratería",
      "pillaje",
      "interrupción",
      "saqueo",
    ],
  },
  {
    label: "Especiales",
    path: "/especiales",
    keywords: [
      "misceláneos",
      "productos",
      "especiales",
      "seguros",
      "equipo",
      "contratistas",
      "robo",
      "bienes",
      "empresariales",
      "dinero",
      "valores",
      "rotura",
      "maquinaria",
      "electrónico",
      "obras",
      "arte",
      "objetos",
      "alto",
      "valor",
      "incendio",
      "rayo",
      "explosión",
      "riesgos",
      "hidrometeorológicos",
      "temblor",
      "terremoto",
      "sismo",
      "erupción",
      "volcánica",
      "derrumbe",
      "deslave",
      "hundimiento",
      "terreno",
      "alud",
      "responsabilidad",
      "civil",
      "daños",
      "terceros",
    ],
  },
  {
    label: "Ciberseguridad",
    path: "/ciberseguridad",
    keywords: [
      "seguros",
      "ciber",
      "ciberseguridad",
      "cyber",
      "cibernética",
      "informática",
      "digital",
      "seguridad",
      "servidores",
      "poder",
      "datos",
      "electrónicos",
      "robo",
      "pérdida",
      "comunicación",
      "divulgación",
      "información",
      "multas",
      "autoridad",
      "terceros",
      "operación",
      "responsabilidad",
      "privacidad",
      "estándar",
      "tarjetas",
      "pagos",
      "servicios",
      "remediación",
      "extorsión",
      "propios",
      "daños",
      "protección",
      "páginas",
      "web",
      "contenido",
      "derivado",
      "ingresos",
      "forense",
      "informático",
      "negocio",
      "dependiente",
    ],
  },
  {
    label: "Fianzas",
    path: "/fianzas",
    keywords: [
      "fianzas",
      "seguros",
      "personales",
      "legal",
      "seguridad",
      "financiera",
      "aval",
      "respaldo",
      "contrato",
      "incumpla",
      "incumplir",
      "incumplimiento",
      "afianzadora",
      "contratante",
      "obligación",
      "administrativas",
      "fiscales",
      "fidelidad",
      "suministro",
      "programa",
      "proveedores",
      "arrendamiento",
      "tipos",
    ],
  },
  {
    label: "Paquete empresarial",
    path: "/paquete-empresarial",
    keywords: [
      "seguros",
      "paquete",
      "empresarial",
      "empresa",
      "trabajadores",
      "patrimonio",
      "incendios",
      "desastres",
      "daños",
      "negocio",
      "protección",
      "materiales",
      "robo",
      "mercancía",
      "dinero",
      "valores",
      "rotura",
      "cristales",
      "anuncios",
      "luminosos",
      "calderas",
      "responsabilidad",
      "civil",
      "terceros",
      "orientación",
      "médica",
      "pérdidas",
      "inmueble",
    ],
  },
];
